import {MutationCache, QueryCache, QueryClient} from '@tanstack/react-query'
import {logger} from "@/logger/logger";

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => logger.error('Query Cache Error', error)
  }),
  mutationCache: new MutationCache({
    onError: (error, _, __, mutation) => logger.error('Query Mutation Error', error, { mutation })
  })
  /*defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 2,
    },
  },*/
})